import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  IconUser, IconHistory, IconMapPin, IconLock, IconLogout, IconChevronRight, IconBell, IconPencil,
} from '@tabler/icons-react';
import { Avatar, BottomSheet, Button } from '../../components/common';
import profileApi from '../../api/profile/profileApi';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { PATHS } from '../../routes/paths';
import { formatPhone, maskIC } from '../../utils/format';

const MENU = [
  { to: PATHS.profileEdit, label: 'Personal details', Icon: IconUser },
  { to: PATHS.history, label: 'Appointment history', Icon: IconHistory },
  { to: PATHS.clinic, label: 'Clinic info', Icon: IconMapPin },
  { to: PATHS.changePassword, label: 'Change password', Icon: IconLock },
];

export default function ProfilePage() {
  const { user, signOut, updateUser } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const [confirmLogout, setConfirmLogout] = useState(false);

  const toggleReminders = async (e) => {
    const smsReminders = e.target.checked;
    updateUser({ ...user, smsReminders });
    try {
      const next = await profileApi.update({ smsReminders });
      updateUser(next);
    } catch (err) {
      updateUser({ ...user, smsReminders: !smsReminders });
      toast.show(err.message, 'error');
    }
  };

  const logout = async () => {
    await signOut();
    navigate(PATHS.landing, { replace: true });
  };

  return (
    <div className="page page--with-nav profile">
      <div className="profile__top">
        <h1 className="page__title">Profile</h1>
      </div>
      <div className="page__body u-stack-4">
        <section className="card card--pad profile__card">
          <Avatar name={user?.name} />
          <div className="u-grow">
            <p className="profile__name">{user?.name}</p>
            <p className="u-muted">{formatPhone(user?.countryCode, user?.phone)}</p>
            <p className="u-muted u-text-sm">{`IC ${maskIC(user?.icNumber)}`}</p>
          </div>
          <Link to={PATHS.profileEdit} className="icon-btn" aria-label="Edit profile"><IconPencil size={20} /></Link>
        </section>

        <section className="list-card">
          {MENU.map(({ to, label, Icon }) => (
            <Link key={to} to={to} className="list-row">
              <span className="icon-tile"><Icon size={20} /></span>
              <span className="list-row__body list-row__title">{label}</span>
              <IconChevronRight size={20} className="list-row__chevron" />
            </Link>
          ))}
        </section>

        <section className="list-card">
          <label className="list-row" htmlFor="sms-reminders">
            <span className="icon-tile"><IconBell size={20} /></span>
            <span className="list-row__body">
              <span className="list-row__title">SMS reminders</span>
              <span className="list-row__sub" style={{ display: 'block' }}>Get a text before every appointment</span>
            </span>
            <span className="switch">
              <input id="sms-reminders" type="checkbox" checked={!!user?.smsReminders} onChange={toggleReminders} />
            </span>
          </label>
        </section>

        <Button variant="danger-outline" block onClick={() => setConfirmLogout(true)}>
          <IconLogout size={20} />
          Log out
        </Button>
      </div>

      <BottomSheet
        open={confirmLogout}
        onClose={() => setConfirmLogout(false)}
        title="Log out?"
        description="You’ll need your mobile number to log in again."
        actions={(
          <>
            <Button block onClick={logout}>Log out</Button>
            <Button variant="outline" block onClick={() => setConfirmLogout(false)}>Stay logged in</Button>
          </>
        )}
      />
    </div>
  );
}
